module.exports = __webpack_public_path__ + "static/img/qr1.1fe7a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr1.png
// module id = 1267
// module chunks = 1